import { CommissionCard } from '@fasstech/middle-design-system';
import { mapIndexed } from '../../../../../server/helpers/index.mjs';
import { Controller } from 'react-hook-form';
import { useEffect } from 'react';
import handleValidationIndicator from './helpers/handleValidationIndicator';
import getErrorMessage from './helpers/getErrorMessage';

const ControlledCommissionCard = ({
  form,
  title,
  infoMessage,
  infoIconName = 'lightbulb',
  commissionTypeName = 'commission.type',
  commissionsFieldName = 'commissions',
  commissions = [],
  radioOptions = [],
  selectOptions = [],
  selectLabel,
  isDisplayed = true,
  'data-testid': dataTestId,
  rules = {},
  ...props
}) => {
  if (!isDisplayed) {
    return null;
  }

  const selectedCommissionType = form.watch(commissionTypeName);
  const shouldShowRadio = radioOptions.length > 1;

  const selects = mapIndexed((commission, idx) => {
    const fieldName = `${commissionsFieldName}.${idx}.rate`;
    const fieldValue = form.watch(fieldName);

    return {
      name: fieldName,
      label: selectLabel,
      options: selectOptions,
      value: fieldValue || '',
      onChange: (e) => {
        form.setValue('commission.rate', e.target.value);
        form.setValue(fieldName, e.target.value);
        form.trigger(fieldName);
      },
      isDisplayed: commission.code === selectedCommissionType,
      withIndicator: false
    };
  }, commissions);

  return <Controller
    name={commissionTypeName}
    control={form.control}
    rules={rules}
    render={({ field: value }) => {

      const errorMessage = getErrorMessage(form.formState.errors, commissionTypeName);

      const radioError = handleValidationIndicator(
        value.value,
        rules,
        errorMessage
      );

      useEffect(() => {
        form.trigger(commissionTypeName);
        return () => {
          form.clearErrors(commissionTypeName);
        };
      }, [value]);
      return <CommissionCard
        title={title}
        infoMessage={infoMessage}
        infoIconName={infoIconName}
        data-testid={dataTestId}
        radioValue={selectedCommissionType}
        radioOptions={radioOptions}
        radioError={radioError}
        radioErrorMessage={errorMessage}
        showRadio={shouldShowRadio}
        radioOnChange={(e) => {
          form.setValue(commissionTypeName, e);
        }}
        selects={selects}
        {...props}
      />;
    }}
  />;
};

export default ControlledCommissionCard;
